export interface CustomField {
    id: number;
    enabled: boolean;
    targetTable?: string | null;
    targetField?: string | null;
    targetMethod?: string | null;
    type: CustomFieldType;
    invoiceType: InvoiceType;
    sourcePattern?: string | null;
    separator?: number | null;
    excludedLineTypes: ExcludedLineType[];
    ttpMessageSourceFields?: TtpMessageSourceField[] | null;
}

export interface ExcludedLineType {
    type: number;
    label: string;
}

export interface Separator {
    separator: number;
    label: string;
}

export interface TtpMessageSourceField {
    field: string;
    line: number;
    name: string;
}

export enum CustomFieldType {
    CustomField1 = 0,
    CustomField2 = 1,
    CustomField3 = 2,
}

export enum InvoiceType {
    None = 0,
    Po = 1,
    NonPo = 2,
}
